module.exports = __webpack_public_path__ + "static/home-callout-9cc187d4f40661d986c39ee445f0c58d.png";